/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../hook/use-api-handler";
import { logger } from "../utils/logger";

const useOrgBenifitDataHook = () => {
	const [benifitData, setBenifitData] = useState({})
	const { fetchData } = useAPIHandler();
	function getBenefitDataFn() {
		fetchData({ url: "/organization/get-organization-benefit" })
			.then((res) => {
				try {
					setBenifitData(res?.data || {});
				} catch (error) {
					logger.log(error)
				}
			})
			.catch((err) => {
				logger.log(err)
			});
	}
	useEffect(() => {
		getBenefitDataFn()
	}, [])
	return {
		benifitData
	}
}

export default useOrgBenifitDataHook